import { createColumnHelper } from "@tanstack/react-table";

import TableCheckboxCol from "../../../shared/Tables/IndeterminateCheckbox";
import { QuoteTabType } from "../../../../models/Lead";
import { ITableQuote } from "../../../../models/Quote";
import QuoteCallStageCell, {
  QuoteAgeCell,
  QuoteCalcTypeCell,
  QuoteCustomerCell,
  QuotePartsSalvageCell,
  QuotePriceCell,
  QuoteSourceCell,
  QuoteTabTypeCell,
  QuoteTradeValueCell,
  QuoteVehicleCell,
} from "./QuoteTableCells";

const quoteColHelper = createColumnHelper<ITableQuote>();

export const getQuoteColumns = (
  onQuoteTabTypeChange: (leadId: string, quoteTabType: QuoteTabType) => void
) => [
  TableCheckboxCol(true, true),
  quoteColHelper.accessor((row) => row.vehicle?.vrm ?? "", {
    id: "Vehicle.Vrm",
    header: "Vehicle",
    sortingFn: "auto",
    cell: (info) => <QuoteVehicleCell quote={info.row.original} />,
  }),
  quoteColHelper.accessor((row) => row.contact?.fullname ?? "", {
    id: "Contact.Fullname",
    header: "Customer",
    enableSorting: false,
    cell: (info) => <QuoteCustomerCell quote={info.row.original} />,
  }),
  quoteColHelper.accessor((row) => row.price, {
    id: "Price",
    header: "Price",
    sortingFn: "auto",
    cell: (info) => <QuotePriceCell value={info.getValue()} />,
  }),
  quoteColHelper.accessor((row) => row.quoteType, {
    id: "QuoteType",
    header: "Calc Type",
    enableSorting: false,
    cell: (info) => <QuoteCalcTypeCell quoteType={info.getValue()} />,
  }),
  quoteColHelper.accessor((row) => row.vehicle?.valuationTradePoor ?? null, {
    id: "Vehicle.ValuationTradePoor",
    header: "Trade Value",
    sortingFn: "auto",
    cell: (info) => <QuoteTradeValueCell value={info.getValue()} />,
  }),
  quoteColHelper.display({
    id: "salvageEstimate",
    header: "Parts / Salvage",
    cell: (info) => <QuotePartsSalvageCell quote={info.row.original} />,
  }),
  quoteColHelper.display({
    id: "callStage",
    header: "Call Stage",
    cell: (info) => <QuoteCallStageCell quote={info.row.original} />,
  }),
  quoteColHelper.display({
    id: "quoteStage",
    header: "Quote Stage",
    cell: (info) => <>-</>,
  }),
  quoteColHelper.display({
    id: "quoteType",
    header: "Quote Type",
    cell: (info) => (
      <QuoteTabTypeCell
        quote={info.row.original}
        onQuoteTabTypeChange={onQuoteTabTypeChange}
      />
    ),
  }),
  quoteColHelper.accessor((row) => row.website, {
    id: "Website",
    header: "Source",
    enableSorting: false,
    cell: (info) => <QuoteSourceCell quote={info.row.original} />,
  }),
  quoteColHelper.accessor((row) => row.created, {
    id: "Created",
    header: "Age",
    sortingFn: "auto",
    cell: (info) => <QuoteAgeCell created={info.getValue()} />,
  }),
];
